import * as React from 'react'

import styled from '@emotion/styled'

import { getColor } from '../theme/colors'
import Header, { HeaderVariants } from './Header'
import PaddingInset from './PaddingInset'

export type PageHeaderProps = {
  title: React.ReactNode
  subtext?: React.ReactNode
  titleVariant?: HeaderVariants
  titleElement?: React.ElementType
  children?: React.ReactNode
}

const Container = styled(PaddingInset)`
  display: grid;
  row-gap: 1rem;
  max-width: ${props => props.theme.maxWidths.content};

  ${props => props.theme.typography.bodyText};
`

const Subtext = styled.p`
  color: ${getColor('secondaryLabel')};
  line-height: 1.5rem;
  max-width: 30.5rem;
`

const PageHeader: React.FC<PageHeaderProps> = ({ titleElement, titleVariant, subtext, title, children }) => (
  <Container>
    <Header variant={titleVariant ?? 'header-3'} as={titleElement ?? 'h1'}>
      {title}
    </Header>
    {subtext != null ? <Subtext>{subtext}</Subtext> : null}
    {children}
  </Container>
)

export default PageHeader
